import { Badge } from '../../../school_panel/components/ui';

const LABEL: Record<string, string> = { worksheet: 'Worksheet', homework: 'Homework' };

/** Badge for worksheets and homework; nothing for exams or when the kind is unknown. */
export default function KindBadge({ kind, className }: { kind?: string | null; className?: string }) {
  const label = kind ? LABEL[kind] : undefined;
  if (!label) return null;
  return <Badge tone="primary" size="sm" className={className}>{label}</Badge>;
}
